/**
 * Favorite assets services
 * asset format:
 * {
 *   id: integer,
 *   category: string
 * }
 */
services.service('FavoritesService', [
    'constants', 'LocalStorage', 'UserService',
    function (Const, LocalStorage, UserService) {
        var key,
            defaultKey = 'favorites',
            entities = [];

        this.init = function () {
            setKey();
            load();
        };

        function load() {
            try {
                entities = JSON.parse(LocalStorage.get(key)) || [];
            } catch (e) {
                LocalStorage.remove(key);
                entities = [];
            }
        }

        function sync(data) {
            LocalStorage.set(key, JSON.stringify(data || entities));
        }

        function setKey() {
            var user = UserService.get();

            if (user && user.activeTradingAccount) {
                key = [defaultKey, user.login, user.activeTradingAccount.id].join('|');
            } else {
                key = [defaultKey, user.login].join('|');
            }

            return key;
        }

        this.getAll = function () {
            load();
            return entities;
        };

        this.get = function (id) {
            return _.find(entities, function (item) {
                return item === id
            })
        };

        this.add = function (id) {
            load();
            entities.push(id);
            sync();
        };

        this.remove = function (id) {
            _.remove(entities, function (item) {
                return item === id
            });
            sync();
        };

        this.length = function () {
            return entities.length;
        };

        this.clearAll = function () {
            entities.length = 0;
            LocalStorage.remove(key);
        };

        this.clear = function () {
            entities.length = 0;
            key = defaultKey;
        };

        this.sync = sync;

        return this;
    }]);